import type { FormEvent, ReactNode } from 'react';

interface FilterBarProps {
  children: ReactNode;
  onSubmit?: (event: FormEvent) => void;
  className?: string;
  asForm?: boolean;
}

/** Thin wrapper around the shared `.filter-bar` layout. */
export function FilterBar({
  children,
  onSubmit,
  className = '',
  asForm = true
}: FilterBarProps) {
  const cls = `filter-bar${className ? ` ${className}` : ''}`;

  if (asForm) {
    return (
      <form className={cls} onSubmit={onSubmit}>
        {children}
      </form>
    );
  }

  return <div className={cls}>{children}</div>;
}
